var FIGURE = FIGURE || {};

// FIGURE.shippingMessage = function() {
// 	var specialMessageModal = $.cookie('specialmessage');
// 	if (specialMessageModal == 'read') {
// 		return;
// 	} else {
// 		setTimeout(function(){
// 			$('#figureMessageModal').modal();
// 		}, 3000);
// 	}
// 	$('#figureMessageModal').on('hide.bs.modal', function (event) {
// 		$.cookie('specialmessage', 'read', { path: '/' });
// 	});
// 	$('#figureMessageModal a').click(function() {
// 		$.cookie('specialmessage', 'read', { path: '/' });
// 	});
// }();

FIGURE.quoteCarousel = function() {
	const $inner = $("#carouselQuote .carousel-inner");
	const $items = $("#carouselQuote .carousel-item");
	var maxHeight = 0;

	$inner.children('.carousel-item').each(function () {
		var $item = $(this);

		$item.addClass('active-measuring');
		var height = $item.outerHeight();
		$item.removeClass('active-measuring');

		if (height > maxHeight) {
			maxHeight = height;
		}
	});

	$inner.css('min-height', `${maxHeight}px`);
	$inner.css('height', `${maxHeight}px`);
	$items.css('min-height', `${maxHeight}px`);
	$items.css('height', `${maxHeight}px`);
}();
